import React from 'react';
import { object, number } from 'yup';
import { get } from 'lodash';
import { FieldArray, useFormikContext } from 'formik';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FieldArrayCards from './FieldArrayCards.jsx';
import ListResource from '../lists/ListResource.jsx';

const defaults = {
  name: '',
  stableName: '',
  address: '',
  active: true,
  gxeEarned: 0,
  racingCount: 0,
  breedingCount: 0,
  trainingCount: 0,
  rentingCount: 0,
  avatar: '',
  spirit: 100,
  inventory: [],
};

const FormPlayer = ({ player }) => {
  return (
    <FormResource
      {...{
        defaults,
        schema: object({
          gxeEarned: number().min(0),
        }),
        stored: player,
        api: '/api/site/players',
      }}>
      {({ values }) => (
        <Tabs defaultActiveKey="profile">
          <Tab eventKey="profile" title="Profile">
            <div className="form-row">
              <div className="col">
                <FormGroup name="name" label="Name" />
                <FormGroup
                  name="stableName"
                  label="Stable Name"
                />
                <FormGroup name="address" />
                <div className="form-group">
                  <label>Active</label>
                  <FormCheckGroup
                    name="active"
                    type="checkbox"
                    label=""
                    asSwitch
                  />
                </div>
              </div>
              <div className="col">
                <FormGroup
                  name="avatar"
                  label="Avatar"
                  as="coverImg"
                  api="/api/site/players/files"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="col">
                <FormGroup
                  name="gxeEarned"
                  type="number"
                  min={0}
                  label="GXE Earned"
                />
              </div>
              <div className="col">
                <FormGroup
                  name="racingCount"
                  type="number"
                  min={0}
                  label="Racing"
                />
              </div>
              <div className="col">
                <FormGroup
                  name="breedingCount"
                  type="number"
                  min={0}
                  label="Breeding"
                />
              </div>
              <div className="col">
                <FormGroup
                  name="trainingCount"
                  type="number"
                  min={0}
                  label="Training"
                />
              </div>
              <div className="col">
                <FormGroup
                  name="rentingCount"
                  type="number"
                  min={0}
                  label="Renting"
                />
              </div>
              <div className="col">
                <FormGroup
                  name="spirit"
                  type="number"
                  min={0}
                  max={100}
                />
              </div>
            </div>
          </Tab>
          <Tab eventKey="inventory" title="Inventory">
            <>
              <FieldArray name="inventory">
                {(helper) => {
                  const arr = get(values, 'inventory', []);
                  return (
                    <>
                      <div className="row">
                        <div className="col">
                          <ListResource
                            {...{
                              searchable: true,
                              api: '/api/site/items',
                              sort: { createdAt: 1 },
                              filter: { active: true },
                              actions: {
                                create: false,
                                remove: false,
                              },
                              onRowClick: (row) => {
                                const included = arr.map(
                                  (r) => r.item._id
                                );
                                if (status?.disabled)
                                  return null;
                                const index =
                                  included.indexOf(row._id);
                                if (index === -1) {
                                  return helper.push({
                                    item: row,
                                    quantity: 1,
                                  });
                                }
                                if (
                                  arr[index].quantity + 1 >
                                  row.maxStack
                                )
                                  return null;

                                helper.replace(index, {
                                  ...arr[index],
                                  quantity:
                                    arr[index].quantity + 1,
                                });
                                return null;
                              },
                              cols: [
                                {
                                  key: 'name',
                                  sortable: true,
                                },
                                {
                                  key: 'description',
                                  sortable: true,
                                },
                                {
                                  key: 'prices.dge',
                                  sortable: true,
                                  children: 'DGE',
                                },
                                {
                                  key: 'prices.gxe',
                                  sortable: true,
                                  children: 'GXE',
                                },
                              ],
                            }}
                          />
                        </div>
                        <div className="col">
                          <FieldArrayCards
                            name="inventory"
                            disabled={status?.disabled}>
                            {(s, i) => (
                              <>
                                <div className="row">
                                  <div className="col">
                                    <FormGroup
                                      name={`inventory.${i}.item.name`}
                                      label="Name"
                                      disabled
                                    />
                                  </div>
                                  <div className="col">
                                    <FormGroup
                                      name={`inventory.${i}.item.description`}
                                      label="Description"
                                      disabled
                                    />
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col">
                                    <FormGroup
                                      name={`inventory.${i}.item.type`}
                                      label="Type"
                                      disabled
                                    />
                                  </div>
                                  <div className="col">
                                    <FormGroup
                                      name={`inventory.${i}.item.subType`}
                                      label="Sub Type"
                                      disabled
                                    />
                                  </div>
                                  <div className="col">
                                    <FormGroup
                                      name={`inventory.${i}.quantity`}
                                      label="Quantity"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </FieldArrayCards>
                        </div>
                      </div>
                    </>
                  );
                }}
              </FieldArray>
            </>
          </Tab>
        </Tabs>
      )}
    </FormResource>
  );
};

export default FormPlayer;
